import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ExamState} from '@store/exam/exam.reducer';
import {StoreFeatureSelectorEnum} from '@store/store.enum';

export class ExamSelectors {
    static readonly getState = createFeatureSelector<ExamState>(StoreFeatureSelectorEnum.Exam);

    static readonly selectRemindoExam = createSelector(ExamSelectors.getState, (state: ExamState) => state.exam);
}
